import * as React from 'react';
import { Input, Select } from 'antd';
import * as update from 'immutability-helper';
import StaticView from './StaticView';
const Option = Select.Option;
const InputGroup = Input.Group;
import { get } from 'pc-sales/utils/http';
import statics from 'common/statics';

interface PhoneState {
    codes: Array<{
        key: string;
        name: string;
        phone_code: string;
        country_name_en: string;
    }>;
    phoneCode: string;
}

export default class Phone extends React.Component<any, PhoneState> {
    static fieldName = 'phone';
    static defaultProps = {
        lang: 'zh-CN',
        ipConfig: '/v2/control/location/show',
        preventIpConfig: false
    };
    mounted: boolean = null;

    // 值变化
    changeHandler = (index: 0 | 1) => (data: string) => {
        const { value, onChange } = this.props;
        onChange && onChange(update((value || [this.state.phoneCode]), {
            [index]: { $set: index === 0 ? data.match(/\+\d+$/)[0] : data },
            ...(index === 0 ? { 2: { $set: data.match(/\[(\S*)\]/)[1] } } : {})
        }));
    };

    // 失焦
    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    constructor(props: any) {
        super(props);
        this.state = {
            codes: null,
            phoneCode: null
        };
    }

    componentDidMount() {
        this.mounted = true;
        this.initData().catch();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    initData = async () => {
        let { ipConfig, initialValue, preventIpConfig, extension, countryList: codes } = this.props;
        if (!codes) {
            const [phoneCodes] = await statics.index('phoneCodes');
            codes = phoneCodes;
        }
        extension && extension(codes);
        let phoneCode = codes[0].phone_code;
        // 是否启用ip识别
        if (!!ipConfig && !preventIpConfig) {
            if (initialValue && initialValue[0]) {
                phoneCode = initialValue[0];
            } else {
                const ipPhoncode = window.localStorage.getItem('ipPhoncode');
                if (!ipPhoncode) {
                    const location = await get(ipConfig).catch(); // 地区信息
                    const phone: any = codes.find((val: any) => val.key === (location.value || '1')); // 区号信息
                    phoneCode = phone && phone.value || codes[0].phone_code;
                    this.mounted && this.props.onChange([phoneCode]);
                } else {
                    this.mounted && this.props.onChange([ipPhoncode]);
                }
            }
        }
        this.mounted && this.setState({ codes, phoneCode });
    };

    render() {
        const { placeholder, initialValue, disabled, staticView, value, showDecrypt, decryptConfig, countryList } = this.props;
        let { codes, phoneCode } = this.state;
        if (countryList) codes = countryList;
        const code = (value && value[0]) || phoneCode || window.localStorage.getItem('ipPhoncode');
        return (
            (staticView && disabled)
                ? <StaticView display={initialValue} showDecrypt={showDecrypt} decryptConfig={decryptConfig} adaptFn={(val: any) => val && val[1] && `(${val[0]}) ${val[1]}`} />
                : <InputGroup compact style={{ height: 32, display: "flex" }}
                    className={(staticView && disabled) ? 'Form-static-view' : ''}>
                    <Select placeholder={placeholder[0]} defaultValue={code}
                        dropdownMatchSelectWidth={false} dropdownStyle={{ width: 'auto' }}
                        onChange={this.changeHandler(0)} style={{ minWidth: 80 }} value={code}
                        optionFilterProp='label' showSearch
                        disabled={disabled}>
                        {codes && codes.map(({ key, name, country_name_en, phone_code }) =>
                            <Option key={`[${key}]${phone_code}`} label={name}>
                                <p className="intl-code" data-code={`（${phone_code}）`} data-name={name || country_name_en} title={name || country_name_en} />
                            </Option>)}
                    </Select>
                    <Input placeholder={placeholder[1]} defaultValue={(initialValue && initialValue[1]) || ''} value={(value && value[1]) || ''}
                        onChange={(e: any) => this.changeHandler(1)(e.target.value)} onBlur={this.blurHandler}
                        style={{ flex: "1" }} disabled={disabled} />
                </InputGroup>
        );
    }
}
